<template>
	<div class="pb-3" style="max-width: 1320px;">
		
		<div
			class="p-3 shadow w-100 border-15 overflow-hidden bg-white"
			style="z-index: 100;  top:0px; max-width: 1320px; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;"
			:style="'right: ' + (100 - ( 1330 / windowWidth * 100 ))/2 + '%;'"
		>
			<a href="https://easytick.ir" class="float-right ml-3">
				<img
					height="35px;"
					:src="img.Logo_Header"
					alt="ایزی تیک"
					title="ایزی تیک"
				/>
			</a>
			<a href="https://siadat.net/" class="float-right">
				<btn
					id_btn="home_btn_id"
					type="white"
				  	text="خانه"
					shadow="0"
					class="float-right"
					textClass="w-100 m-auto text-center"
					:textClass = "(pathname == '/') ? 'under-line' : ''"
				/>
			</a>
			<!-- <a  href="https://easytick.ir/#8" target="_blank" class="float-right">
				<btn
					shadow="0"
					class="float-right"
					textClass="w-100 m-auto text-center"
					type="white"
					text="مقالات"
				/>
			</a>
			<a href="https://easytick.ir/#9" class="float-right">
				<btn
					shadow="0"
					class="float-right"
					textClass="w-100 border-hover m-auto text-center"
					type="white"
					text="درباره ما"
					:textClass = "(pathname == '/aboutMe') ? 'under-line' : ''"
				/>
			</a> -->
			<!-- <router-link to="/contact" class="float-right">
				<btn
					shadow="0"
					class="float-right"
					textClass="w-100 border-hover m-auto text-center"
					type="white"
					text="تماس با ما"
					:textClass = "(pathname == '/contact') ? 'under-line' : ''"
				/>
			</router-link> -->

			<router-link to="/signup_all" class="float-left" v-if="$localStorage.get('user')==null" style="margin-right: 4px;">
				<btn type="success" text="ثبت نام" style_btn="width: 88px;" />
			</router-link>
			
			<router-link to="/oneTimePassword" class="float-left" v-if="$localStorage.get('user')==null">
				<btn type="outline-success" text="ورود" style_btn="width: 88px;" />
			</router-link>
			<btn
				type="success"
				text="حساب کاربری"
				@clickMe="userL = !userL"
				class="float-left"
				v-if="$localStorage.get('user')!=null"
			/>
		</div>
		<!-- ---------------------------------------------------------------------- -->
		<div
			class="bg-white shadow mt-2 border-15 pt-3 pb-3 border"
			style="position: fixed; z-index:100; width: 200px; top: 50px; overflow-y: auto; max-height: 90vh; "
			:style="('height: '+ (flds.length + 1) * 44 +'px;') + 'left:' + set_degrees_margin()+'; ' + ((btnSelect == -2) ? '' : 'border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important;')"
			data-aos="fade-down"
			data-aos-duration="1500"
			v-if="mgt"
		>
		<a href="/teachers" >
				<btn
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover m-auto"
					type="white"
					text="همه"
					@mousemove="btnSelect = -2"
				/>
		</a>
		<a :href="'/teacher/'+f.en_title" v-for="(f, i) in flds" :key="i" >
				<btn
					@clickMe="(e)=>{ mgt = false;}"
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover m-auto text-left"
					:text="f.name"
					:img="require('../assets/img/Arrow_Left2.svg')"
					imgSize="10px"
					styleImg="position: absolute; left: 15px;"
					@mousemove="btnSelect = i"
					:type="(btnSelect == i) ? 'outline-success' : 'white'"
				/>
		</a>
		</div>
		<!-- ----------------------------------------------------------------- -->
		<div
			class="bg-white shadow mt-2 border-15 pt-3 pb-3 border"
			style="position: fixed; z-index:100; width: 200px; top: 50px; border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important; max-height: 90vh; overflow-y: auto;"
			:style="'height: '+ (flds.length + 1) * 44 +'px;' + 'left:' + set_degrees_margin(-200)+'; '"
			data-aos="zoom-in-left"
			v-if="btnSelect!=-2 &&  mgt"
			@mouseleave="btnSelect = -2;"
		>
		<a 
		v-for="(f, j) in flds[btnSelect].category" :key="j" 
		:href="'/teacher/'+ flds[btnSelect].en_title+'/'+f.en_title" 
			>
				<btn
					@clickMe="(e)=>{ mgt = false;}"
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover m-auto"
					type="white"
					:text="f.name"
					imgSize="10px"
					styleImg="position: absolute; left: 15px;"
					@mousemove="btnSelect2 = j"
					:type="(btnSelect2 == j) ? 'outline-success' : 'white'"
				/>
	</a>
		</div>

		<div
			v-if="userL"
			dir="ltr"
		>
			<div
				id="menu_left_small"
				class="bg-white shadow mt-2 col-3 border-15 pt-3 pb-3 w-100"
				style="position: absolute; z-index: 100; width: 300px !important;"
				data-aos="fade-down"
				data-aos-duration="1500"

			>
				<router-link to="/reserved/user/list" >
					<btn
						shadow="0"
						class="w-100"
						textClass="w-100 border-hover m-auto text-center"
						type="white"
						text="تیکت‌ها"
					/>
				</router-link>
				<!-- <router-link to="/class/list" >
					<btn
						shadow="0"
						class="w-100"
						textClass="w-100 border-hover m-auto text-center"
						type="white"
						text="مدیریت کلاس ها"
						v-if="this.$localStorage.get('user').username.role=='2'"
					/>
				</router-link> -->
				<!-- <btn
					v-if="this.$localStorage.get('user').username.role==1"
					:type="(select=='1') ? 'orange' : 'white'"
					shadow="0"
					class="w-100"
					textClass="w-100 border-hover"
					text="درخواست تغییر و ارتقا"
				/>
				<router-link to="/self" v-else>
					<btn
						:type="(select=='1') ? 'orange' : 'white'"
						shadow="0"
						class="w-100"
						textClass="w-100 border-hover"
						text="ویرایش اطلاعات"
					/>
				</router-link> -->

				<btn
					id_btn="exit_btn_id_web"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover m-auto text-center text-danger"
					type="white"
					text="خروج"
					@clickMe="exit(1)"
				/>
				<btn
					id_btn="exit_btn_id_mobile"
					v-show="false"
					class="w-100"
					shadow="0"
					textClass="w-100 border-hover m-auto text-center text-danger"
					type="white"
					text="خروج"
					@clickMe="exit(2)"
				/>
			</div>
		</div>

		<div style="
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0;
			top: 0;
			background-color: #5454547a;
			z-index: 2;
			"
			v-if="mgt"
			@click="setMgt()"
			data-aos="flip-left"
		>
		</div>


	</div>
</template>

	<script>
		import Logo_Header from '../assets/img/Logo_Header.svg';
		import ArrowDown from '../assets/img/Arrow_Down.svg';
		import btn from  "../UI/button/btn.vue";
		
  	import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
		export default {
			name: 'headMenu',
			data(){
				return {
					pathname: window.location.pathname,
					mgt: false,
					userL: false,
					btnSelect: -2,
					btnSelect2: -2,
					img: {
							"Logo_Header": Logo_Header,
							"ArrowDown": ArrowDown,
					}
				}
			},
			props: ["flds"],
			components: {
				btn,
			},
			mounted(){
				document.body.scrollTop = 0;
			},
			methods:{
				//************************************************************
				set_degrees_margin(add=0){
					var element = document.getElementById("degrees");
					var rect = element.getBoundingClientRect();
					return rect.x + add;
				},
				//************************************************************
				setMgt(){
					this.mgt = !this.mgt;
				},
				//************************************************************
				serch_box(e){
					var val = e.target.value.trim();
					if(val!=""){
						// this.$router.push({ path: 'teachers', query: { search: val }})
						location.replace("/teachers?search="+val);
					}
				},
				//************************************************************
				show_search(){
					return !(location.pathname=='/teachers' || location.pathname.includes('/teacher/'))
				},
				//************************************************************
				exit(mod="1"){
					this.$swal.fire({
						position: 'center',
						type: '',
						title: "خروج از حساب",
						html: "<div class='text-center w-75 m-auto'><hr/> آیا مطمئن هستید می خواهید از حساب کاربری خود خارج شوید.</div>",
						showCloseButton: true,
						showConfirmButton: true,
						confirmButtonText: "خیر",
						confirmButtonClass:"btn btn-outline-success border w-50",
						showCancelButton: true,
						cancelButtonText: "بلی خروج!",
						cancelButtonClass:"btn btn-danger w-50",
					}).then((result) => {
						if (result.dismiss=="cancel") {
							this.$localStorage.remove('user');
							var rtr = (mod=="1") ? "/" : "/login";
							if(window.location.pathname == rtr){
								location.reload();
							} else {
								// this.$router.push(rtr);
								location.replace(rtr);
							}
						}
					})
				}
			}
		}
	</script>
<style>
	@import "../css/templatemo-main.css";
	.under-line{
		text-decoration: underline;
		text-decoration-color: #FFB013;
		text-decoration-style: solid;
		text-decoration-thickness: 15%;
		text-underline-position: under;
		text-underline-offset: 5px;

	}
</style>
